<script lang="ts">
	import PageGrid from '../components/pageGrid.svelte';
	import Image from '../components/image.svelte';
	import type { SbImage } from '../types';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			title: string;
			subtitle: string;
			imageA?: SbImage;
			labelA?: string;
			imageB?: SbImage;
			labelB?: string;
			rows: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="text-center text-brown-1">
	<PageGrid>
		<div class="col-span-full">
			<h1
				class="text-[32px]/[110%] font-semibold tracking-[-.32px] lg:text-[48px]/[110%] lg:tracking-[-.48px]"
			>
				{content.title}
			</h1>
			<h2 class="my-4 text-[16px]/[140%] text-brown-2 lg:text-[24px]">
				{content.subtitle}
			</h2>
		</div>

		<div class="col-span-full grid grid-cols-4 gap-x-6 lg:grid-cols-12">
			<Image
				wrapperClass="col-span-2 lg:col-span-6 xl:col-start-3 xl:col-end-7"
				class="h-full w-full select-none object-contain"
				src={content.imageA?.filename ?? ''}
				alt={content.imageA?.alt ?? ''}
				title={content.imageA?.title ?? ''}
				width={680}
			/>
			<Image
				wrapperClass="col-span-2 lg:col-span-6 xl:col-start-7 xl:col-end-11"
				class="h-full w-full select-none object-contain"
				src={content.imageB?.filename ?? ''}
				alt={content.imageB?.alt ?? ''}
				title={content.imageB?.title ?? ''}
				width={680}
			/>
		</div>

		{#if content.labelA?.length || content.labelB?.length}
			<div class="col-span-full grid grid-cols-4 gap-x-6 border-b border-stone-2 lg:grid-cols-12">
				<p
					class="col-span-2 bg-white py-4 text-[18px]/[120%] font-semibold lg:col-span-6 lg:pb-10 lg:text-[32px]/[110%] xl:col-start-3 xl:col-end-7"
				>
					{content.labelA}
				</p>
				<p
					class="col-span-2 bg-white py-4 text-[18px]/[120%] font-semibold lg:col-span-6 lg:pb-10 lg:text-[32px]/[110%] xl:col-start-7 xl:col-end-11"
				>
					{content.labelB}
				</p>
			</div>
		{/if}

		<div class="col-span-full">
			{#each content.rows as row}
				<div class="border-b border-stone-2 last:border-none">
					<Blok content={row} />
				</div>
			{/each}
		</div>
	</PageGrid>
</section>
